<template>
	<el-container>
		<el-main>
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">个人设置</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">设置常用邀请用语</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="InviteTable" v-for="(table,ind) in TableLst" :key="ind">
				<div class="TableTitle">
					<div class="TitleText">{{table.title}}</div>
					<div class="AddBtn">
						<el-button type="primary" @click="add(ind,table.type,table.table)" size="mini" class="item_font">添加</el-button>
					</div>
				</div>
				<div class="table">
					<el-table v-bind:data="table.table" border :header-cell-style="headerStyle" :cell-style="cellStyle" stripe max-height="400">
						<el-table-column prop="content" label="常用语内容" min-width="70%"></el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: row;justify-content: space-around;">
									<el-button @click="edit(ind,table.type,table.table,scope)" type="text" size="small">编辑</el-button>
									<el-button type="text" size="small" @click="delet(ind,table.type,table.table,scope)">删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!-- <div class="save">
				<el-button type="primary" @click="save">保存</el-button>
			</div> -->
			<!-- 操作弹窗 -->
			<div v-show="PopUps">
				<el-dialog :title="PopUpsTitle.title" style="height: 430px;" :visible.sync="PopUps" custom-class="dialog" :close-on-click-modal="false" :close-on-press-escape="false" width="30%" center>
					<div style="height: 100px;">
						<el-input type="textarea" cols="2" rows="4" placeholder="请输入内容" v-model="inputValue">
						</el-input>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="PopUps = false">取 消</el-button>
						<el-button type="primary" @click="confirm(PopUpsTitle.slogon)">确 定</el-button>
					</div>
				</el-dialog>

			</div>
			<div v-show="length">
				<el-button type="text" @click="open"></el-button>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	import {MessageBox} from 'element-ui';	
	export default {
		data() {
			return {
				TableLst: [{
						'title': '新访客邀请语',
						'type': 'new',
						'table': []
					},
					{
						'title': '历史访客邀请语',
						'type': 'old',
						'table': []
					}
				],
				PopUpsTitle: {
					title: '',
					slogon: '',
					index: '',
					id: ''
				},
				PopUps: false,
				length: false,
				inputValue: '',
				table:'',
				type:''

			}
		},
		mounted() {
			this.invitationNew()
			this.invitationOld()
		},
		methods: {
			async invitationNew() {
				var api = "/manager/invitation/select";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current: 1,
						type:0,
						size:10
					},
				});
				console.log("invitationNew response = ", response.data);
				this.TableLst[0].table=response.data
				
			},
			async invitationOld() {
				var api = "/manager/invitation/select";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current: 1,
						type:1,
						size:10
					},
				});
				console.log("invitationOld response = ", response.data);
				this.TableLst[1].table=response.data
				
			},
			async editAdd() {
				console.log("正在编辑或添加的表格",this.table)
				var api = "/manager/invitation/edit";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: this.table.id,
						content:this.inputValue,
						type:this.type
					},
				});
				console.log("editAdd invitation response = ", response);
				if(this.type==0){
					console.log("重新查询0",this.type)
					this.invitationNew()
				}else{
					console.log("重新查询1",this.type)
					this.invitationOld()
				}
				if(response.resultCode==="10000"){
					this.open1("保存成功")
				}else{
					this.open2(response.desc)
				}
				
			},
			async del(slogon) {
				var api = "/manager/invitation/del";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: this.table.id,
					},
				});
				console.log("del invitation response = ", response);
				if(slogon=='new'){
					console.log("重新查询",slogon)
					this.invitationNew()
				}else{
					console.log("重新查询",slogon)
					this.invitationOld()
				}
				if(response.resultCode==="10000"){
					this.open1("删除成功")
				}else{
					this.open2(response.desc)
				}
				
			},
			open() {
				this.$alert('邀请语最多5条', '提醒');
			},
			add(index, type, table) {
				console.log("点击增加", index, type, table)
				this.PopUpsTitle.index = index
				this.PopUpsTitle.slogon = "add"
				
				if (table.length >= 5) {
					this.open()
				} else {
					if (type == 'new') {
						console.log("增加新访客邀请语")
						this.PopUpsTitle.title = "增加新访客邀请语"
						this.type=0
					} else {
						console.log("增加历史访客邀请语")
						this.PopUpsTitle.title = "增加历史访客邀请语"
						this.type=1
					}
					this.PopUps = true
				}
				this.table = table
				

			},
			edit(index, type, table, scope) {
				this.PopUpsTitle.index = index
				this.inputValue = scope.row.content
				this.PopUpsTitle.id = scope.$index
				this.PopUpsTitle.slogon = "edit"
				this.table = table[scope.$index]
				console.log("点击编辑", index, type, this.table, scope, this.inputValue)
				if (type == 'new') {
					console.log("编辑新访客邀请语")
					this.PopUpsTitle.title = "编辑新访客邀请语"
					this.type=0
				} else {
					console.log("编辑历史访客邀请语")
					this.PopUpsTitle.title = "编辑历史访客邀请语"
					this.type=1
				}
				this.PopUps = true
			},
			delet(index, type, table, row) {
				console.log("点击删除", index, type, table, row)
				const tipMsg = "是否确认删除"
				MessageBox.alert(tipMsg, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(()=>{
					this.table = table[row.$index]
					this.del(type)
				})	
				
				
				// if (type == 'new') {
				// 	this.TableLst[index].table.splice(row.$index, 1)
				// 	this.type=0
				// 	console.log("删除新访客邀请语")
				// } else {
				// 	this.TableLst[index].table.splice(row.$index, 1)
				// 	console.log("删除历史访客邀请语")
				// 	this.type=1
				// }
			},
			save() {
				console.log("点击保存")
			},
			close() {
				this.PopUps = false
				this.inputValue = ''
			},
			cancel() {
				this.PopUps = false
				this.inputValue = ''
			},
			confirm(slogon) {
				this.inputValue=this.inputValue.replace(/\s+/g,"");       

				if(this.inputValue===""){
					this.open2(" 邀请语不能为空 ")
				}else{
					this.PopUps = false
					console.log("确定", slogon, this.type, this.inputValue, this.PopUpsTitle,this.table)
					this.editAdd()
					this.inputValue = ''
					console.log(this.TableLst)
				}
				
			},
			activated() {
				this.confirm()
			},
			headerStyle({
				rowIndex,
				columnIndex
			}) {
				// console.log(row, column, rowIndex, columnIndex)
				if (rowIndex == 0 && columnIndex == 1) {
					return 'text-align:center;color:#000000'
				} else {
					return 'text-align:left;padding:15px;color:#000000'
				}

			},
			cellStyle({
				columnIndex
			}) {
				// console.log(row, column, rowIndex, columnIndex)
				if (columnIndex == 1) {
					return 'text-align:center;'
				} else {
					return 'text-align:left;padding:15px;'
				}
			},
			open1(info) {
				const text = info
				this.$message.success(text)
				// console.log(info)
			},
			open2(info) {
				const text = info + ' 保存失败 '
				this.$message.error(text)
			},
		}
	}
</script>

<style lang="scss">
	.container {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.InviteTable {
		width: 100%;
		/* margin: 0 auto; */
		margin-bottom: 20px;
	}

	.TableTitle {
		width: 100%;
		display: flex;
		/* margin: 0 auto; */
		justify-content: space-between;
		height: 50px;
	}

	.TitleText {
		width: 70%;
		height: 50px;
		line-height: 50px;
		text-align: left;
		line-height: 40px;
		font-weight: bold;
		@include change_size($font_size_normal)
	}

	.AddBtn {
		height: 50px;
		margin-top: 5px;
	}

	.table {
		width: 100%;
		/* margin: 0 auto; */
		margin-bottom: 30px;
	}
	.cell{
		@include change_size($font_size_normal)
	}
	.save {
		width: 80px;
		margin: 0 auto;
		margin-top: 60px;
	}

	.opr {
		width: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #35b9ff;
		cursor: pointer;
	}
	.el-button .el-button--primary .el-button--mini{
		@include change_size($font_size_normal)
	}
</style>
